import { Surface, Text } from '@lawpilots/design-system'
import { Box } from '@mui/material'

import emptyListImage from '@/public/images/empty-list.svg'

// Mirrors the courses-overview empty state: a carded panel on the DS Surface, a centred
// illustration and copy, no call to action - a learner can neither assign themselves a course nor
// award themselves a certificate. The illustration reuses the shared house drawing for
// consistency with every other empty state; the prototypes' own drawings are flagged at design
// review (FS-332 plan §4.4, FS-333 plan decision 3).

const ContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '24px',
  padding: '80px 24px',
}

const IllustrationStyles = {
  width: '240px',
  height: '174px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}

const CopyStyles = { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }

type LearnerEmptyStateProps = {
  title: string
  description: string
}

export const LearnerEmptyState = ({ title, description }: LearnerEmptyStateProps): JSX.Element => (
  <Surface>
    <Box sx={ContentStyles} data-testid="learner-empty-state">
      <Box sx={IllustrationStyles}>
        {/* Decorative: the heading below says the same thing, so an alt would only repeat it. */}
        <img src={emptyListImage} alt="" style={{ maxWidth: '100%', maxHeight: '100%' }} />
      </Box>
      <Box sx={CopyStyles}>
        <Text variant="section-title" color="primary" style={{ textAlign: 'center' }}>
          {title}
        </Text>
        <Text
          variant="body-reading"
          color="secondary"
          style={{ textAlign: 'center', maxWidth: '448px', whiteSpace: 'pre-line' }}>
          {description}
        </Text>
      </Box>
    </Box>
  </Surface>
)
